import Step from 'shepherd.js/src/types/step';
import {
  SHEPHERD_NEXT_BUTTON_CLASSES,
  SHEPHERD_PREVIOUS_BUTTON_CLASSES,
  SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT,
} from '../constants';
import { SHEPHERD_CARD_TYPES } from '../model';

export namespace LandingPageShepherdScenario {
  export function getScenarioSteps(): Array<Step.StepOptions> {
    const attachShepherdStepCounterElement = this.attachShepherdStepCounterElement.bind(this);
    const attachShepherdCardElement = this.attachShepherdCardElement.bind(
      this,
      SHEPHERD_CARD_TYPES.GRID
    );
    const shepherdService = this.shepherdService;
    const viUIService = this.viUIService;

    return [
      {
        id: 'landingPageIntro',
        arrow: false,
        classes: 'shepherd-grid-modal shepherd-bottom-left',
        buttons: [
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              if (window.innerWidth < SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT) {
                viUIService.sidenav$.next();
              }

              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_PURPOSE.TITLE'),
        text: [this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_PURPOSE.DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdCardElement();
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'landingPageSidenav',
        canClickTarget: false,
        attachTo: {
          element:
            window.innerWidth < SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT
              ? 'data-at-learning-center'
              : 'app-sidenav',
          on: 'right',
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              if (window.innerWidth < SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT) {
                viUIService.sidenav$.next();
              }

              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              if (window.innerWidth < SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT) {
                viUIService.sidenav$.next();
              }

              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_SIDENAV.TITLE'),
        text: [this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_SIDENAV.DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'landingPageSiteMenu',
        canClickTarget: false,
        attachTo: {
          element: '[data-at-menu-button]',
          on: 'bottom',
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              if (window.innerWidth < SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT) {
                viUIService.sidenav$.next();
              }

              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_SITE_MENU.TITLE'),
        text: [this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_SITE_MENU.DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'landingPageTileConfiguration',
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToTop();
        },
        attachTo: {
          element: '[data-at-dashboard-configuration]',
          on: 'bottom',
        },
        modalOverlayOpeningRadius: 20,
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant(
          '+SHEPHERD.LANDING_PAGE.STEP_TILE_CONFIGURATION.TITLE'
        ),
        text: [
          this.translateService.instant(
            '+SHEPHERD.LANDING_PAGE.STEP_TILE_CONFIGURATION.DESCRIPTION'
          ),
        ],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'snapshotSynchronize',
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToTop();
        },
        attachTo: {
          element: '[data-at-snapshot-synchronize]',
          on: 'bottom',
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.SYNCHRONIZE_BUTTON.TITLE'),
        text: [this.translateService.instant('+SHEPHERD.SYNCHRONIZE_BUTTON.DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'landingPageTileTabs',
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElement('app-dashboard-tile');
        },
        attachTo: {
          element: '[data-at-tile-tabs]',
          on: 'bottom',
        },
        showOn: (): boolean => {
          return Boolean(document.querySelector('[data-at-tile-tabs]'));
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_TILE_TABS.TITLE'),
        text: [this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_TILE_TABS.DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'landingPageTileNavigation',
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElement('app-dashboard-tile');
        },
        attachTo: {
          element: '[data-at-tile-navigation-action]',
          on: 'bottom',
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        highlightClass: 'highlight',
        title: this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_TILE_NAVIGATION.TITLE'),
        text: [
          this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_TILE_NAVIGATION.DESCRIPTION'),
        ],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'landingPageTileDetails',
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElement('app-dashboard-tile');
        },
        attachTo: {
          element: '[data-at-tile-show-more-action]',
          on: 'bottom',
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.CLOSE'),
            action(): void {
              shepherdService.complete();
            },
          },
        ],
        highlightClass: 'highlight',
        title: this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_TILE_DETAILS.TITLE'),
        text: [
          this.translateService.instant('+SHEPHERD.LANDING_PAGE.STEP_TILE_DETAILS.DESCRIPTION'),
        ],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
    ];
  }
}
